import * as React from 'react';
import { useSelector } from 'react-redux';

import { useDeviceType } from '@cian/ui-kit';

import { PreviewImg } from '../../components/packages/PreviewImg';
import { getPreviewImage } from '../../selectors/listing';

export interface ICardAvatarContainerProps {
  agentId: number;
  isCircleImage?: boolean;
}

export function CardAvatarContainer({ agentId, isCircleImage }: ICardAvatarContainerProps) {
  const deviceType = useDeviceType();
  const { imgUrl, firstLetter } = useSelector(getPreviewImage(agentId));

  const imageSize = deviceType === 'desktop' ? 64 : 56;

  return (
    <PreviewImg width={imageSize} height={imageSize} firstLetter={firstLetter} url={imgUrl} circle={isCircleImage} />
  );
}
